export const categoryData = [
  {
    categoryName: 'Coaching Institute',
  },
  {
    categoryName: 'College',
  },
  {
    categoryName: 'Corporate ',
  },
  {
    categoryName: 'Education ',
  },
  {
    categoryName: 'Government ',
  },
  {
    categoryName: 'NGO',
  },
  {
    categoryName: 'School',
  },
  {
    categoryName: 'University',
  },
]
